import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './guards/auth.interceptor';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';


export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor])),
    DatePipe,CurrencyPipe,
    { provide: LocationStrategy, useClass: HashLocationStrategy }


  ]
};
